import axios from "axios";
import toast from "react-hot-toast";

export const BASE_URL = "https://api.oillogistics.co.in/api";
export const BASE_URL_IMAGE = "https://api.oillogistics.co.in/";

const client = axios.create({
   baseURL: BASE_URL,
});

let isRedirectingToLogin = false;

const isLoginPage = () => {
   const path = window.location.pathname.toLowerCase();
   return path === "/login" || path.startsWith("/login/");
};

const clearAuthStorage = () => {
   localStorage.removeItem("token");
   localStorage.removeItem("persist:root");
};

const redirectToLogin = () => {
   if (isRedirectingToLogin || isLoginPage()) return;
   isRedirectingToLogin = true;
   window.location.replace("/Login");
};

const handleUnauthorized = (message) => {
   clearAuthStorage();
   if (!isLoginPage()) {
      toast.error(message || "Session expired. Please login again.");
      redirectToLogin();
   }
};

const isUnauthorizedStatus = (value) => Number(value) === 401;

client.interceptors.request.use(
   (config) => config,
   (error) => Promise.reject(error)
);

client.interceptors.response.use(
   (response) => {
      const { data } = response;

      if (
         data &&
         data.statusCode != null &&
         data.statusCode !== 200 &&
         data.statusCode !== 201
      ) {
         const message = data.errors
            ? Object.values(data.errors)?.[0]?.[0]
            : data.message;

         if (isUnauthorizedStatus(data.statusCode)) {
            handleUnauthorized(message);
            return Promise.reject(data);
         }

         toast.error(message || "Validation Error");
         console.error("API Error (Success Block):", message, data);
         return Promise.reject(data);
      }

      return response;
   },
   (error) => {
      console.log("Response Interceptor Error:", error);

      if (error.response) {
         const { status, data } = error.response;
         const bodyStatusCode = data?.statusCode;
         const message = data?.errors
            ? Object.values(data.errors)?.[0]?.[0]
            : data?.message;

         if (isUnauthorizedStatus(status) || isUnauthorizedStatus(bodyStatusCode)) {
            handleUnauthorized(message || "Unauthorized. Please login again.");
            return Promise.reject(error);
         }

         if (status === 422) {
            toast.error(message || "Validation error");
            console.error("Validation Error (422):", message);
         } else if (status === 500) {
            toast.error("Server error. Please try again later.");
            console.error("Server Error (500)");
         } else {
            toast.error(message || "Something went wrong");
            console.error(`API Error (${status}):`, message);
         }
      } else if (error.request) {
         toast.error("Network error. Please check your connection.");
         console.error("Network Error:", error.request);
      }

      return Promise.reject(error);
   }
);

export default client;
